import type { ComponentType } from "react";
import type { Group } from "../types";

export type CustomRegistry = Record<
  string,
  ComponentType<{
    group: Group;
    endpoint: string;
    /** Optional: panel reports dirty transitions for upstream visual hint. */
    onDirtyChange?: (dirty: boolean) => void;
  }>
>;

interface Props {
  group: Group;
  endpoint: string;
  registry: CustomRegistry;
  onDirtyChange?: (dirty: boolean) => void;
}

export function CustomPanelHost({
  group,
  endpoint,
  registry,
  onDirtyChange,
}: Props) {
  const key = group.custom_component ?? "";
  const Cmp = registry[key];
  if (!Cmp) {
    return (
      <section className="rounded-lg border border-warning-soft bg-warning-soft p-6 text-sm text-warning-soft-foreground">
        <h3 className="font-semibold">Panel not registered</h3>
        <p className="mt-1">
          The manifest declares custom component{" "}
          <code className="font-mono rounded bg-warning-soft-foreground/10 px-1 py-0.5">
            {key || "(none)"}
          </code>{" "}
          for group{" "}
          <code className="font-mono rounded bg-warning-soft-foreground/10 px-1 py-0.5">
            {group.key}
          </code>
          , but no React component is registered under that key. Pass a{" "}
          <code className="font-mono">customRegistry</code> to{" "}
          <code className="font-mono">&lt;SettingsPage /&gt;</code>.
        </p>
      </section>
    );
  }
  return <Cmp group={group} endpoint={endpoint} onDirtyChange={onDirtyChange} />;
}
